import React from "react";
import "./gap8.scss";
const Gap8 = ({ childs }) => {
  return <div className="gap-8">{childs}</div>;
};

export default Gap8;
